/**
 * Cart Bundle Tiers — logique dynamique du module cart-bundle-tiers.liquid
 * Chargée au niveau du thème (layout/theme.liquid) pour survivre aux re-renders
 * du cart drawer (Dawn fait innerHTML = ... qui n'exécute pas les scripts inline).
 */
(function(){
  if (window.__cartBundleTiersInstalled) return;
  window.__cartBundleTiersInstalled = true;

  var currency = 'EUR';
  if (window.Shopify && window.Shopify.currency) {
    currency = window.Shopify.currency.active || 'EUR';
  }

  function formatMoney(cents){
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
        style: 'currency', currency: currency
      }).format(cents / 100);
    } catch(e) {
      return (cents / 100).toFixed(2) + ' €';
    }
  }

  /* Convert **text** → <b>text</b> (markdown-style bold)
     Convert \n (retour à la ligne dans le textarea du user) → <br> */
  function parseBold(str){
    if (!str) return '';
    return String(str)
      .replace(/\*\*([^*]+)\*\*/g, '<b>$1</b>')
      .replace(/\n/g, '<br>');
  }

  /* ═══ Coordination anti-boucle ═══
     - _cbtBusy = true pendant une opération interne (removeInvalidGifts, refetch en cours)
       → interdit les relances par intercepteur fetch/XHR/events
     - _refreshTimer = debounce pour éviter les rafales de refreshFromCart
     - _internalHeaderMarker = header custom sur les /cart/* internes → l'intercepteur skip */
  var _cbtBusy = false;
  var _refreshTimer = null;
  function scheduleRefresh(delay){
    if (_cbtBusy) return;
    if (_refreshTimer) clearTimeout(_refreshTimer);
    _refreshTimer = setTimeout(function(){
      _refreshTimer = null;
      refreshFromCart();
    }, delay || 300);
  }

  function computeMaxPct(slots, totalQty){
    var maxPct = 0;
    slots.forEach(function(s){
      var th = parseInt(s.dataset.threshold, 10) || 0;
      if (totalQty >= th) {
        var m = (s.dataset.reward || '').match(/(\d+)\s*%/);
        if (m) { var p = parseInt(m[1], 10); if (p > maxPct) maxPct = p; }
      }
    });
    return maxPct;
  }

  /* ═══ Gift pickers ═══
     Setup handlers pour tous les gift dialogs sur la page.
     idempotent : n'ajoute pas les handlers 2 fois grâce au flag dataset */
  function setupGiftDialogs(){
    document.querySelectorAll('[data-cbt-gift-dialog]').forEach(function(dlg){
      if (dlg.dataset.cbtHandlersInstalled) return;
      dlg.dataset.cbtHandlersInstalled = 'true';
      /* Fermeture backdrop */
      dlg.addEventListener('click', function(e){ if (e.target === dlg) dlg.close(); });
      /* Sélection d'un cadeau → /cart/add.js avec property _bundle_gift
         Gardes anti-doublon :
         (1) Si un cadeau est déjà pické pour ce tier (__cbtCartGifts) → close, no-op
         (2) Update optimiste de __cbtCartGifts[tier] AVANT le fetch pour empêcher qu'une
             ré-ouverture du popup entre-temps (via observer avec state stale) ajoute un second gift
         (3) Flag data-cbt-picking sur tous les boutons du dialog pour bloquer le double-click. */
      dlg.querySelectorAll('[data-cbt-gift-pick]').forEach(function(btn){
        btn.addEventListener('click', function(){
          var variantId = btn.dataset.variantId;
          var tier = btn.dataset.tier;
          if (window.__cbtCartGifts && window.__cbtCartGifts[tier]) { dlg.close(); return; }
          if (dlg.dataset.cbtPicking === 'true') return;
          dlg.dataset.cbtPicking = 'true';
          /* Optimistic set — bloque tout auto-open concurrent */
          window.__cbtCartGifts = window.__cbtCartGifts || {};
          window.__cbtCartGifts[tier] = true;
          window.__cbtAutoOpenedTiers = window.__cbtAutoOpenedTiers || {};
          window.__cbtAutoOpenedTiers[tier] = true;
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
              items: [{
                id: parseInt(variantId, 10),
                quantity: 1,
                properties: {
                  _is_gift: 'true',           /* reconnu par le thème Bellom pour afficher "Cadeau Offert" */
                  _bundle_gift: '1',
                  _gift_from_tier: String(tier)
                }
              }]
            })
          }).then(function(r){ return r.json(); })
            .then(function(){
              dlg.close();
              delete dlg.dataset.cbtPicking;
              /* Déclenche un cartUpdated pour rafraîchir le drawer */
              document.dispatchEvent(new CustomEvent('cartUpdated'));
              /* Refresh drawer via l'API Dawn si dispo */
              if (window.PUB_SUB_EVENTS && window.publish) {
                try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, {source: 'cbt-gift'}); } catch(e){}
              }
              /* Fallback : recharge le contenu du cart drawer */
              refreshCartDrawer();
            })
            .catch(function(err){
              console.error('CBT gift add error', err);
              delete dlg.dataset.cbtPicking;
              /* Rollback optimistic set si le fetch a échoué */
              if (window.__cbtCartGifts) delete window.__cbtCartGifts[tier];
            });
        });
      });
    });
  }

  /* Refresh le contenu du cart drawer sans recharger la page */
  function refreshCartDrawer(){
    fetch('/?section_id=cart-drawer', { cache: 'no-store' })
      .then(function(r){ return r.text(); })
      .then(function(html){
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newDrawer = doc.querySelector('cart-drawer');
        var oldDrawer = document.querySelector('cart-drawer');
        if (newDrawer && oldDrawer) {
          oldDrawer.innerHTML = newDrawer.innerHTML;
        }
      })
      .catch(function(){});
  }

  /* ═══ Auto-open des popups gift quand un palier gift est atteint ═══
     Le tracking d'auto-open est window-level (pas dataset sur <dialog>) car le dialog
     est re-créé par Dawn lors des re-renders → dataset perdu → doubles ouvertures. */
  window.__cbtAutoOpenedTiers = window.__cbtAutoOpenedTiers || {};
  function checkAndOpenGiftDialogs(totalQty){
    /* suppressAll UNIQUEMENT quand le client vient de la section bundle builder
       (dans ce cas tous les cadeaux ont déjà été choisis là-bas).
       Ne PAS suppresser juste parce qu'un autre tier a déjà un cadeau : chaque tier gift
       est indépendant et doit pouvoir déclencher son popup séparément. */
    document.querySelectorAll('[data-cbt-gift-dialog]').forEach(function(dlg){
      var threshold = parseInt(dlg.dataset.threshold, 10) || 0;
      var tier = dlg.dataset.tier;
      var reached = totalQty >= threshold;
      /* Vérifie si le cadeau de ce tier est déjà dans le panier */
      var alreadyPicked = window.__cbtCartGifts && window.__cbtCartGifts[tier];
      var alreadyAutoOpened = !!window.__cbtAutoOpenedTiers[tier];
      if (reached && !alreadyPicked && !alreadyAutoOpened && !dlg.open) {
        window.__cbtAutoOpenedTiers[tier] = true;
        setTimeout(function(){
          if (typeof dlg.showModal === 'function' && !dlg.open) dlg.showModal();
        }, 400);
      }
      /* Reset autoOpen tracking quand le seuil n'est plus atteint (permet re-auto-open si le user revient au-dessus). */
      if (!reached) {
        delete window.__cbtAutoOpenedTiers[tier];
      }
    });
  }

  /* Applique les réductions visuelles :
     - chaque line item du cart drawer : prix original barré + prix avec réduction
     - le bouton "Procéder au paiement" : "Procéder au paiement - {discounted} {crossed}" (barré à droite) */
  function applyDiscountsToCartUI(maxPct, totalCents, discountedTotal){
    if (maxPct <= 0) {
      /* Reset : retire les prix discount ajoutés + restaure les prix cachés + retire les barrés custom */
      document.querySelectorAll('[data-cbt-item-discount]').forEach(function(el){ el.remove(); });
      document.querySelectorAll('[data-cbt-hidden-by="cbt"]').forEach(function(el){
        el.style.display = '';
        el.removeAttribute('data-cbt-hidden-by');
      });
      document.querySelectorAll('[data-cbt-original-price]').forEach(function(el){
        el.style.textDecoration = '';
        el.style.opacity = '';
        el.style.fontWeight = '';
        el.removeAttribute('data-cbt-original-price');
      });
      /* Même sans % palier atteint, si économie absolue (shipping offerte, reward_values) → CTA "Continuer — {net} {barré}" */
      if (totalCents > 0 && discountedTotal >= 0 && discountedTotal < totalCents) {
        updateCheckoutBtn(discountedTotal, totalCents);
      } else {
        resetCheckoutBtn();
      }
      return;
    }

    /* Line items : plus de modification par ligne — Shopify auto-discount applique déjà
       le % au niveau cart, le thème l'affiche via item.final_price. On nettoie seulement
       les résidus des versions précédentes du code. */
    document.querySelectorAll('[data-cbt-item-discount]').forEach(function(el){ el.remove(); });
    document.querySelectorAll('[data-cbt-hidden-by="cbt"]').forEach(function(el){
      el.style.display = '';
      el.removeAttribute('data-cbt-hidden-by');
    });

    /* CTA "Procéder au paiement" */
    updateCheckoutBtn(discountedTotal, totalCents);
  }

  function findCheckoutBtn(){
    /* Cherche le bouton checkout du cart drawer (labels FR + fallback selectors) */
    var candidates = document.querySelectorAll('button, a, input[type="submit"]');
    for (var i = 0; i < candidates.length; i++) {
      var b = candidates[i];
      var t = (b.textContent || b.value || '').toLowerCase();
      if (t.indexOf('procéder au paiement') !== -1 ||
          t.indexOf('continuer') !== -1 ||
          t.indexOf('checkout') !== -1 ||
          t.indexOf('paiement') !== -1) {
        /* Filtre : doit être dans le drawer */
        if (b.closest('cart-drawer, .cart-drawer, .drawer')) return b;
      }
    }
    return null;
  }

  function updateCheckoutBtn(discountedCents, originalCents){
    var btn = findCheckoutBtn();
    if (!btn) return;
    /* Store initial HTML une fois */
    if (!btn.dataset.cbtOriginalHtml) btn.dataset.cbtOriginalHtml = btn.innerHTML;
    /* Flex inline pour garantir un espace propre entre chaque bloc */
    var showBarred = originalCents > discountedCents;
    btn.innerHTML =
      '<span style="display:inline-flex;align-items:baseline;gap:8px;">' +
        '<span style="font-weight:700;">Continuer —</span>' +
        '<span style="font-weight:800;">' + formatMoney(discountedCents) + '</span>' +
        (showBarred ? '<s style="font-size:0.82em;opacity:0.55;font-weight:500;">' + formatMoney(originalCents) + '</s>' : '') +
      '</span>';
  }

  function resetCheckoutBtn(){
    var btn = findCheckoutBtn();
    if (btn && btn.dataset.cbtOriginalHtml) {
      btn.innerHTML = btn.dataset.cbtOriginalHtml;
    }
  }

  /* Intercepte le clic checkout du drawer pour chaîner les codes discount
     stockés par la section bundle builder (sinon les codes ne sont jamais appliqués). */
  function installCheckoutInterceptor(){
    var btn = findCheckoutBtn();
    if (!btn || btn.dataset.cbtCheckoutHooked) return;
    btn.dataset.cbtCheckoutHooked = 'true';
    btn.addEventListener('click', function(e){
      var codes = [];
      try {
        var raw = localStorage.getItem('bellom_pending_discount_codes');
        if (raw) codes = JSON.parse(raw) || [];
      } catch(err){}
      if (!codes.length) return; /* Comportement natif */
      e.preventDefault();
      e.stopPropagation();
      var target = '/checkout';
      for (var i = codes.length - 1; i >= 0; i--) {
        target = '/discount/' + encodeURIComponent(codes[i]) + '?redirect=' + encodeURIComponent(target);
      }
      /* Codes consommés : nettoie pour ne pas re-appliquer au prochain clic */
      try { localStorage.removeItem('bellom_pending_discount_codes'); } catch(err){}
      window.location.href = target;
    }, true);
  }

  /* Met à jour le footer (Total, Réduction, Net à payer).
     Utilise la valeur INITIALE que le thème a rendu dans #cart-summary-total (calculée avec compare_at_price)
     et ajoute simplement shipping_value + reward_values. */
  function updateCartFooterTotal(shippingReached, shippingValueCents, extraRewardCents, discountedCents){
    var totalEl = document.getElementById('cart-summary-total');
    var reductionEl = document.getElementById('cart-summary-reduction');
    var netEl = document.getElementById('cart-summary-net');
    if (!totalEl) return;

    /* Capture la valeur initiale rendue par le thème AVANT toute modification par moi.
       Le thème calcule original_price + gift_total (utilise compare_at_price). */
    if (!totalEl.dataset.cbtBaseCents) {
      var raw = totalEl.textContent.trim().replace(/[^\d,.]/g, '').replace(',', '.');
      var initialCents = Math.round(parseFloat(raw) * 100);
      if (!isNaN(initialCents) && initialCents > 0) {
        totalEl.dataset.cbtBaseCents = String(initialCents);
      }
    }
    var themeBase = parseInt(totalEl.dataset.cbtBaseCents, 10) || 0;

    /* Total affiché = base du thème + reward_values des paliers + shipping_value si offerte */
    var totalTarget = themeBase + (extraRewardCents || 0) + (shippingReached && shippingValueCents > 0 ? shippingValueCents : 0);
    totalEl.textContent = formatMoney(totalTarget);

    if (netEl) netEl.textContent = formatMoney(discountedCents);
    if (reductionEl) {
      var reduction = Math.max(0, totalTarget - discountedCents);
      reductionEl.textContent = formatMoney(reduction);
    }
  }

  function update(state, opts){
    var root = document.querySelector('[data-cart-bundle-tiers]');
    if (!root) return;

    /* Setup les handlers des gift dialogs (idempotent) */
    setupGiftDialogs();
    /* Setup l'intercepteur du bouton checkout (idempotent — flag sur le btn) */
    installCheckoutInterceptor();

    var slots = root.querySelectorAll('[data-cbt-slot]');
    var messageEl = root.querySelector('[data-cbt-message]');
    var shippingWrap = root.querySelector('[data-cbt-shipping]');
    var shippingFill = root.querySelector('[data-cbt-shipping-fill]');
    var shippingText = root.querySelector('[data-cbt-shipping-text]');

    /* Utilise state (venant de /cart.js) si fourni, sinon lit les data-attrs Liquid.
       Mémorise le dernier state pour permettre un re-apply après re-render Dawn. */
    var totalCents, netCents, upsellCents, giftFinalCents, totalQty, cartImages, shippingThreshold, shippingTextTpl;
    if (state) {
      window.__cbtLastState = state;
      totalCents = state.totalCents;
      netCents = state.netCents !== undefined ? state.netCents : state.totalCents;
      upsellCents = state.upsellCents || 0;
      giftFinalCents = state.giftFinalCents || 0;
      totalQty = state.totalQty;
      cartImages = state.cartImages;
    } else {
      totalCents = parseInt(root.dataset.totalCents, 10) || 0;
      netCents = totalCents;
      upsellCents = 0;
      giftFinalCents = 0;
      totalQty = parseInt(root.dataset.totalQty, 10) || 0;
      cartImages = (root.dataset.cartImages || '').split('|').filter(Boolean);
    }
    shippingThreshold = parseInt(root.dataset.shippingThreshold, 10) || 0;
    /* Le template texte est stocké sur le p au premier render */
    if (shippingText && !shippingText.dataset.tpl) {
      shippingText.dataset.tpl = shippingText.textContent;
    }
    shippingTextTpl = shippingText ? shippingText.dataset.tpl : '';

    var maxPct = computeMaxPct(slots, totalQty);

    /* Somme des reward_values des paliers atteints (valeur perçue des cadeaux) — ajoutée au Total mais pas au Net à payer */
    var extraRewardValueCents = 0;
    slots.forEach(function(slot){
      var th = parseInt(slot.dataset.threshold, 10) || 0;
      if (totalQty >= th) {
        extraRewardValueCents += parseInt(slot.dataset.valueCents, 10) || 0;
      }
    });

    /* discountedTotal = ce que le client paie = cart.total_price directement.
       Depuis que Shopify applique les auto-discounts (10%, 20%) au niveau cart, netCents
       est DÉJÀ discounté. On ne doit PLUS multiplier par (100-maxPct)/100 sinon double.
       Les cadeaux BXGY sont déjà à 0€ dans cart.total_price, donc pas besoin de les soustraire. */
    var discountedTotal = netCents;

    var visibleSlotsCount = parseInt(root.dataset.visibleSlots, 10) || 4;

    /* Slots */
    var nextTier = null;
    var nextTierMessage = null;
    slots.forEach(function(slot, idx){
      var th = parseInt(slot.dataset.threshold, 10) || 0;
      var reached = totalQty >= th;
      slot.classList.toggle('cbt__slot--reached', reached);
      var imgWrap = slot.querySelector('[data-cbt-slot-img]');
      var imgUrl = cartImages[idx];
      if (imgWrap && imgUrl) {
        var existing = imgWrap.querySelector('img');
        if (!existing || existing.getAttribute('src') !== imgUrl) {
          imgWrap.innerHTML = '<img src="' + imgUrl + '" alt="">';
        }
        slot.classList.add('cbt__slot--has-img');
      } else if (imgWrap) {
        imgWrap.innerHTML = '';
        slot.classList.remove('cbt__slot--has-img');
      }
      if (!reached && !nextTier) {
        nextTier = { label: slot.dataset.reward, threshold: th, remaining: th - totalQty };
        nextTierMessage = slot.dataset.message || null;
      }
    });

    /* Slide-in : reveal progressif des slots au-delà de visibleSlotsCount
       Logique position-based : slot idx est révélé quand totalQty >= idx.
       Ex : visible_slots_count=4 → slot 5 (idx=4) apparaît dès qu'il y a 4 articles utiles */
    slots.forEach(function(slot, idx){
      if (idx < visibleSlotsCount) {
        slot.classList.remove('cbt__slot--stashed');
        return;
      }
      slot.classList.toggle('cbt__slot--stashed', totalQty < idx);
    });

    /* Message — utilise le message custom du palier si défini, sinon 2 lignes configurables */
    if (messageEl) {
      if (totalQty === 0) {
        messageEl.innerHTML = messageEl.dataset.defaultMessage || messageEl.textContent;
      } else if (nextTier) {
        if (nextTierMessage && nextTierMessage.trim()) {
          /* Message custom du palier : parse **bold** + placeholders */
          var msg = parseBold(nextTierMessage);
          msg = msg.replace(/\[count\]/g, nextTier.remaining);
          msg = msg.replace(/\[reward\]/g, nextTier.label);
          messageEl.innerHTML = msg;
        } else {
          /* Message générique construit à partir des 2 lignes configurables (line1 + line2 + bold each) */
          var line1Tpl = messageEl.dataset.nextLine1 || 'Plus que [count] produit pour obtenir';
          var line2Tpl = messageEl.dataset.nextLine2 || '[reward]';
          var line1Bold = messageEl.dataset.nextLine1Bold === 'true';
          var line2Bold = messageEl.dataset.nextLine2Bold === 'true';
          var line1 = line1Tpl.replace(/\[count\]/g, nextTier.remaining).replace(/\[reward\]/g, nextTier.label);
          var line2 = line2Tpl.replace(/\[count\]/g, nextTier.remaining).replace(/\[reward\]/g, nextTier.label);
          line1 = parseBold(line1); /* supporte aussi **bold** inline en plus du toggle */
          line2 = parseBold(line2);
          if (line1Bold) line1 = '<b>' + line1 + '</b>';
          if (line2Bold) line2 = '<b>' + line2 + '</b>';
          messageEl.innerHTML = line1 + (line2.trim() ? '<br>' + line2 : '');
        }
      } else {
        /* Rendu différé — on a besoin de crossedTotal (calculé plus bas) pour exposer
           le placeholder [economies] au user. Marque le message comme "à rendre plus tard". */
        messageEl.dataset.pendingUnlockedRender = 'true';
      }
    }

    /* Gift-item slots : révèle les cases OFFERT à droite pour chaque cadeau dans le panier */
    var giftItemSlots = root.querySelectorAll('[data-cbt-gift-item-slot]');
    var anyGiftPicked = false;
    giftItemSlots.forEach(function(giftSlot){
      var tier = giftSlot.dataset.tier;
      var cartGift = window.__cbtCartGiftsData && window.__cbtCartGiftsData[tier];
      var giftPicked = window.__cbtCartGifts && window.__cbtCartGifts[tier];
      var imgWrap = giftSlot.querySelector('[data-cbt-gift-item-img]');
      if (cartGift && cartGift.image) {
        if (imgWrap) {
          var existing = imgWrap.querySelector('img');
          if (!existing || existing.getAttribute('src') !== cartGift.image) {
            imgWrap.innerHTML = '<img src="' + cartGift.image + '" alt="">';
          }
        }
        giftSlot.classList.remove('cbt__slot--stashed');
        giftSlot.classList.add('cbt__slot--has-img');
        anyGiftPicked = true;
      } else if (giftPicked) {
        /* Cadeau dans le panier mais pas d'image → révèle quand même le slot avec le ribbon OFFERT (sans img). */
        if (imgWrap) imgWrap.innerHTML = '';
        giftSlot.classList.remove('cbt__slot--stashed');
        giftSlot.classList.remove('cbt__slot--has-img');
        anyGiftPicked = true;
      } else {
        if (imgWrap) imgWrap.innerHTML = '';
        giftSlot.classList.add('cbt__slot--stashed');
        giftSlot.classList.remove('cbt__slot--has-img');
      }
    });
    /* Séparateur "+" */
    var separator = root.querySelector('[data-cbt-separator]');
    if (separator) separator.classList.toggle('cbt__slots-separator--visible', anyGiftPicked);

    /* Auto-open gift popups quand palier atteint.
       Skip explicitement quand update() est appelé pour un simple reapply DOM
       (MutationObserver → __cbtLastState possiblement stale). Sans ce garde, le popup
       peut se rouvrir juste après un pick avant que refreshFromCart ne rattrape. */
    if (!opts || !opts.skipAutoOpen) {
      checkAndOpenGiftDialogs(totalQty);
    }

    /* Calcule le crossed total : base thème (utilise compare_at_price) + reward_values + livraison si offerte
       Fallback sur totalCents (original_total_price) si le thème n'a pas rendu de valeur */
    /* Livraison offerte évaluée sur netCentsProducts (montant produits, hors Garantie/cadeaux)
       — cohérent avec shippingBase utilisé pour la barre de progression plus bas. */
    var shippingBaseForReached = Math.max(0, netCents - upsellCents - giftFinalCents);
    var shippingReached = shippingThreshold > 0 && shippingBaseForReached >= shippingThreshold;
    var shippingValueCents = parseInt(root.dataset.shippingValueCents, 10) || 0;
    var themeBaseTotal = 0;
    var totalElForBase = document.getElementById('cart-summary-total');
    if (totalElForBase && totalElForBase.dataset.cbtBaseCents) {
      themeBaseTotal = parseInt(totalElForBase.dataset.cbtBaseCents, 10) || 0;
    }
    if (themeBaseTotal <= 0 && totalElForBase) {
      /* Première passe : capture depuis le DOM (avant que je n'écrase) */
      var raw = totalElForBase.textContent.trim().replace(/[^\d,.]/g, '').replace(',', '.');
      themeBaseTotal = Math.round(parseFloat(raw) * 100);
      if (isNaN(themeBaseTotal) || themeBaseTotal <= 0) themeBaseTotal = totalCents;
    }
    if (themeBaseTotal <= 0) themeBaseTotal = totalCents;
    var crossedTotal = themeBaseTotal + extraRewardValueCents + (shippingReached ? shippingValueCents : 0);

    /* Rendu différé du message "toutes récompenses débloquées" avec placeholder [economies] */
    if (messageEl && messageEl.dataset.pendingUnlockedRender === 'true') {
      delete messageEl.dataset.pendingUnlockedRender;
      var allUnlockedMsg2 = messageEl.dataset.allUnlockedMessage || 'Toutes les récompenses débloquées ! 🎉';
      var savingsFormatted = formatMoney(Math.max(0, crossedTotal - discountedTotal));
      messageEl.innerHTML = parseBold(
        allUnlockedMsg2
          .replace(/\[economies\]/g, savingsFormatted)
          .replace(/\[savings\]/g, savingsFormatted)
      );
    }

    /* Applique les réductions visuelles sur chaque line item + CTA du cart drawer */
    applyDiscountsToCartUI(maxPct, crossedTotal, discountedTotal);

    /* Met à jour le footer :
       - Total = valeur initiale du thème (utilise compare_at_price) + reward_values + shipping (si offerte)
       - Net à payer = ce que le client paie réellement
       - Réduction = Total − Net à payer (toutes économies confondues) */
    updateCartFooterTotal(shippingReached, shippingValueCents, extraRewardValueCents, discountedTotal);

    /* Progress livraison — ratio calculé sur netCentsProducts (produits sans Garantie/cadeaux)
       car Shopify calcule habituellement la livraison offerte sur le montant des produits,
       pas sur le total incluant l'assurance transport. */
    if (shippingWrap && shippingThreshold > 0) {
      var shippingBase = Math.max(0, netCents - upsellCents - giftFinalCents);
      var pct = Math.min(100, Math.round(shippingBase / shippingThreshold * 100));
      if (shippingFill) {
        shippingFill.style.setProperty('--cbt-ship-pct', pct + '%');
        shippingFill.style.setProperty('width', pct + '%', 'important');
        shippingFill.style.setProperty('background', shippingBase >= shippingThreshold ? '#2e7d32' : '#1A1A1A', 'important');
        shippingFill.setAttribute('data-cbt-pct', String(pct));
      }
      var remaining = Math.max(0, shippingThreshold - shippingBase);
      if (shippingText) {
        if (remaining === 0) {
          shippingWrap.classList.add('cbt__shipping--reached');
          shippingText.innerHTML = '✓ Livraison offerte débloquée';
        } else {
          shippingWrap.classList.remove('cbt__shipping--reached');
          if (shippingBase === 0) {
            shippingText.innerHTML = shippingTextTpl;
          } else {
            var remainingE = Math.ceil(remaining / 100);
            shippingText.innerHTML = 'Encore <b>' + remainingE + '€</b> pour livraison offerte';
          }
        }
      }
    }
  }

  /* Retire du panier les cadeaux dont le seuil du palier n'est plus atteint.
     Traite 2 cas :
       (A) Cadeau avec _gift_from_tier explicite → vérifie ce tier précisément
       (B) Cadeau orphelin (venant de la section bundle builder ou app tierce,
           sans _gift_from_tier) → tente de l'assigner à un tier gift dont le seuil
           est atteint ; si aucun tier libre → à supprimer
     Retourne une Promise<boolean> (true si des suppressions ont été faites). */
  function removeInvalidGifts(cart, upsellVid){
    /* Pré-calcul du totalQty sans les cadeaux */
    var previewQty = 0;
    (cart.items || []).forEach(function(it){
      if (it.properties && (it.properties._is_gift === 'true' || it.properties._bundle_gift === '1')) return;
      if (upsellVid && it.variant_id === upsellVid) return;
      if (it.final_price === 0) return;
      previewQty += it.quantity;
    });
    /* Enumère les tiers gift (dialogs) par threshold ASC, marque ceux dont le seuil est encore atteint */
    var giftDialogs = Array.prototype.slice.call(document.querySelectorAll('[data-cbt-gift-dialog]'));
    giftDialogs.sort(function(a, b){
      return (parseInt(a.dataset.threshold, 10) || 0) - (parseInt(b.dataset.threshold, 10) || 0);
    });
    var validTiers = {};
    giftDialogs.forEach(function(dlg){
      var t = dlg.dataset.tier;
      var th = parseInt(dlg.dataset.threshold, 10) || 0;
      if (th > 0 && previewQty >= th) validTiers[t] = true;
    });
    var itemsToRemove = [];
    var claimedTiers = {}; /* tiers déjà attribués aux orphelins (1 gift max par tier) */
    /* Passe 1 : cadeaux avec _gift_from_tier → réservent leur tier */
    (cart.items || []).forEach(function(it){
      if (!it.properties) return;
      if (it.properties._is_gift !== 'true' && it.properties._bundle_gift !== '1') return;
      var tier = it.properties._gift_from_tier;
      if (!tier) return;
      if (!validTiers[tier]) {
        itemsToRemove.push(it.key);
      } else {
        claimedTiers[tier] = true;
      }
    });
    /* Passe 2 : cadeaux orphelins → assignation à un tier libre valide, sinon suppression */
    (cart.items || []).forEach(function(it){
      if (!it.properties) return;
      if (it.properties._is_gift !== 'true' && it.properties._bundle_gift !== '1') return;
      if (it.properties._gift_from_tier) return; /* déjà traité en passe 1 */
      var assigned = false;
      for (var i = 0; i < giftDialogs.length; i++) {
        var dt = giftDialogs[i].dataset.tier;
        if (validTiers[dt] && !claimedTiers[dt]) {
          claimedTiers[dt] = true;
          assigned = true;
          break;
        }
      }
      if (!assigned) itemsToRemove.push(it.key);
    });
    if (itemsToRemove.length === 0) return Promise.resolve(false);
    return Promise.all(itemsToRemove.map(function(key){
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-CBT-Internal': '1' },
        body: JSON.stringify({ id: key, quantity: 0 })
      }).catch(function(){});
    })).then(function(){ return true; });
  }

  /* Refetch /cart.js et recalcule le state.
     Coordonné avec _cbtBusy pour éviter les boucles avec les intercepteurs. */
  function refreshFromCart(){
    if (_cbtBusy) return;
    _cbtBusy = true;
    fetch('/cart.js', { cache: 'no-store', headers: { 'X-CBT-Internal': '1' } })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        var root = document.querySelector('[data-cart-bundle-tiers]');
        if (!root) return null;
        var upsellVid = parseInt(root.dataset.upsellVariantId || '0', 10);

        /* Vérifie et retire les cadeaux dont le seuil n'est plus atteint AVANT d'updater l'UI.
           Les requests /cart/change.js portent le header X-CBT-Internal donc l'intercepteur
           ne re-déclenche pas refreshFromCart pendant qu'on est déjà busy. */
        return removeInvalidGifts(cart, upsellVid).then(function(removed){
          if (removed) {
            /* Re-fetch le cart après suppression pour avoir le state final */
            return fetch('/cart.js', { cache: 'no-store', headers: { 'X-CBT-Internal': '1' } })
              .then(function(r){ return r.json(); })
              .then(function(freshCart){
                /* Refresh visuel du drawer pour retirer les lignes gift du DOM */
                refreshCartDrawer();
                return freshCart;
              });
          }
          return cart;
        });
      })
      .then(function(cart){
        if (!cart) { _cbtBusy = false; return; }
        var root = document.querySelector('[data-cart-bundle-tiers]');
        if (!root) { _cbtBusy = false; return; }
        var upsellVid = parseInt(root.dataset.upsellVariantId || '0', 10);

        /* Base "crossed" : cart.original_total_price = total avant TOUS les discounts Shopify.
           Fallback sur cart.total_price si original absent. Matche le "Total" du footer. */
        var totalCents = cart.original_total_price || cart.total_price || 0;
        var netCents = cart.total_price || totalCents; /* après discounts Shopify */
        var upsellCents = 0; /* Garantie Sérénité — exclue du % palier */
        var giftFinalCents = 0; /* Somme des cadeaux à leur final_line_price → à retirer du Net à payer */
        var totalQty = 0;
        var cartImages = [];
        /* Reset tracking cadeaux au début (si retirés du panier, on doit permettre re-pick) */
        window.__cbtCartGifts = {};
        window.__cbtCartGiftsData = {}; /* image + title par tier */
        window.__cbtHasAnyGift = false; /* true dès qu'un cadeau est dans le panier (venant de la section bundle builder ou d'ailleurs) */
        window.__cbtHasBundleBuilder = false; /* true si le client a utilisé la section bundle builder (marker _bundle_builder) */
        window.__cbtGiftLineKeys = {}; /* line item keys des cadeaux — pour skip discount % dans applyDiscountsToCartUI */
        window.__cbtGiftVariantIds = {}; /* variant_ids des cadeaux — fallback si data-key absent du DOM */
        window.__cbtUpsellVid = upsellVid; /* variant_id upsell (Garantie Sérénité) — exposé pour applyDiscountsToCartUI */
        var orphelinGifts = []; /* cadeaux sans _gift_from_tier (venant de la section bundle builder ou apps tierces) */
        (cart.items || []).forEach(function(it){
          /* Détecte si le client a utilisé la section bundle builder (produit page) */
          if (it.properties && it.properties._bundle_builder === '1') {
            window.__cbtHasBundleBuilder = true;
          }
          /* Track cadeaux + capture leur prix (à exclure du Net à payer, ils sont censés être offerts) */
          if (it.properties && (it.properties._is_gift === 'true' || it.properties._bundle_gift === '1')) {
            giftFinalCents += it.final_line_price;
            window.__cbtHasAnyGift = true;
            if (it.key) window.__cbtGiftLineKeys[it.key] = true;
            if (it.variant_id) window.__cbtGiftVariantIds[it.variant_id] = true;
            var tier = it.properties && it.properties._gift_from_tier;
            if (tier) {
              window.__cbtCartGifts = window.__cbtCartGifts || {};
              window.__cbtCartGifts[tier] = true;
              window.__cbtCartGiftsData = window.__cbtCartGiftsData || {};
              window.__cbtCartGiftsData[tier] = { image: it.image, title: it.product_title || it.title };
            } else {
              /* Cadeau orphelin (ajouté par la section bundle builder ou app tierce) → sera assigné
                 à un slot gift libre après le loop, selon threshold ascendant. */
              orphelinGifts.push({ image: it.image, title: it.product_title || it.title });
            }
            /* Skip le comptage totalQty pour les cadeaux */
            return;
          }
          /* Exclut Garantie Sérénité du comptage + capture sa valeur (pour l'exclure du % palier) */
          if (upsellVid && it.variant_id === upsellVid) {
            upsellCents += it.final_line_price;
            return;
          }
          if (it.final_price === 0) return;
          totalQty += it.quantity;
          if (it.image) {
            for (var q = 0; q < it.quantity; q++) cartImages.push(it.image);
          }
        });
        /* Distribution des cadeaux orphelins vers les tiers gift libres, par threshold ascendant.
           Un cadeau orphelin est un item avec _bundle_gift/_is_gift mais sans _gift_from_tier :
           - venant de la section bundle builder (page produit)
           - venant d'une app tierce (EasyGift, FastBundle…) */
        if (orphelinGifts.length > 0) {
          var giftDialogs = Array.prototype.slice.call(document.querySelectorAll('[data-cbt-gift-dialog]'));
          giftDialogs.sort(function(a, b){
            return (parseInt(a.dataset.threshold, 10) || 0) - (parseInt(b.dataset.threshold, 10) || 0);
          });
          for (var gi = 0; gi < giftDialogs.length && orphelinGifts.length > 0; gi++) {
            var gDlg = giftDialogs[gi];
            var gTier = gDlg.dataset.tier;
            var gThreshold = parseInt(gDlg.dataset.threshold, 10) || 0;
            if (window.__cbtCartGifts[gTier]) continue; /* déjà attribué via _gift_from_tier */
            if (totalQty < gThreshold) continue; /* palier non atteint : ne pas remplir */
            var orphelin = orphelinGifts.shift();
            window.__cbtCartGifts[gTier] = true;
            window.__cbtCartGiftsData[gTier] = orphelin;
          }
        }
        update({ totalCents: totalCents, netCents: netCents, upsellCents: upsellCents, giftFinalCents: giftFinalCents, totalQty: totalQty, cartImages: cartImages });
        _cbtBusy = false;
      })
      .catch(function(){ _cbtBusy = false; });
  }

  /* Init dès que le DOM est prêt (ou immédiatement si déjà prêt) */
  function bootstrap(){
    /* Premier render : lit les data-attrs Liquid mais NE déclenche PAS les auto-open des popups.
       __cbtCartGifts n'est pas encore peuplé (aucun /cart.js fetché) → alreadyPicked serait
       faussement false pour un cadeau déjà présent, et le popup se rouvrirait à chaque page load.
       On laisse refreshFromCart (200ms plus tard) faire l'auto-open avec le vrai état. */
    update(undefined, { skipAutoOpen: true });
    /* Après un tour d'event loop, on re-fetch au cas où /cart.js diffère (upsell auto-added etc.) */
    setTimeout(refreshFromCart, 200);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

  /* Listen to cart updates — passe par scheduleRefresh (debounced + busy-safe) */
  ['cartUpdated', 'cart:updated', 'cart:refresh', 'cart:change', 'ajaxCart.afterCartLoad'].forEach(function(ev){
    document.addEventListener(ev, function(){ scheduleRefresh(200); });
  });
  if (window.PUB_SUB_EVENTS && window.subscribe) {
    try { window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function(){ scheduleRefresh(200); }); } catch(e){}
  }

  /* Intercepte fetch pour capturer les mutations panier (add-on Complétez ta routine, drawer natif, etc.)
     — skip si header X-CBT-Internal (requêtes que je fais moi-même)
     — debounce via scheduleRefresh (évite les rafales) */
  var CART_MUTATION_URLS = /\/cart\/(add|change|update|clear)(\.js|$)/;
  function isInternalInit(init){
    if (!init || !init.headers) return false;
    try {
      if (init.headers instanceof Headers) return init.headers.get('X-CBT-Internal') === '1';
      if (typeof init.headers.get === 'function') return init.headers.get('X-CBT-Internal') === '1';
      return init.headers['X-CBT-Internal'] === '1' || init.headers['x-cbt-internal'] === '1';
    } catch(e){ return false; }
  }
  var originalFetch = window.fetch;
  if (originalFetch) {
    window.fetch = function(input, init){
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var isCartMutation = CART_MUTATION_URLS.test(url);
      var promise = originalFetch.apply(this, arguments);
      if (isCartMutation && !isInternalInit(init)) {
        promise.then(function(){ scheduleRefresh(250); }).catch(function(){});
      }
      return promise;
    };
  }

  /* Intercepte XMLHttpRequest (certaines apps utilisent XHR). Le header X-CBT-Internal
     est capturé via setRequestHeader → on skip aussi ces requêtes-là. */
  var xhrProto = XMLHttpRequest.prototype;
  var originalOpen = xhrProto.open;
  var originalSend = xhrProto.send;
  var originalSetHeader = xhrProto.setRequestHeader;
  xhrProto.open = function(method, url){
    this._cbtUrl = url;
    this._cbtInternal = false;
    return originalOpen.apply(this, arguments);
  };
  xhrProto.setRequestHeader = function(name, value){
    if (name && name.toLowerCase() === 'x-cbt-internal' && value === '1') this._cbtInternal = true;
    return originalSetHeader.apply(this, arguments);
  };
  xhrProto.send = function(){
    var xhr = this;
    if (xhr._cbtUrl && CART_MUTATION_URLS.test(xhr._cbtUrl) && !xhr._cbtInternal) {
      xhr.addEventListener('load', function(){ scheduleRefresh(250); });
    }
    return originalSend.apply(this, arguments);
  };

  /* MutationObserver SCOPÉ au cart-drawer uniquement (pas document.body).
     Quand Dawn re-render l'inner du cart-drawer, mes styles line-through + les <span data-cbt-item-discount>
     sont wipés → on ré-applique les discounts depuis le dernier state connu, sans refetch.
     Anti-boucle : on désactive l'observer pendant qu'update() modifie le DOM. */
  var _drawerObserver = null;
  var _reapplyTimer = null;
  var _reapplyInProgress = false;
  function installDrawerObserver(){
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.dataset.cbtObserverInstalled) return;
    drawer.dataset.cbtObserverInstalled = 'true';
    _drawerObserver = new MutationObserver(function(){
      if (!window.__cbtLastState || _reapplyInProgress) return;
      if (_reapplyTimer) clearTimeout(_reapplyTimer);
      _reapplyTimer = setTimeout(function(){
        _reapplyTimer = null;
        _reapplyInProgress = true;
        try { if (_drawerObserver) _drawerObserver.disconnect(); } catch(e){}
        try { update(window.__cbtLastState, { skipAutoOpen: true }); } catch(e){}
        setTimeout(function(){
          try {
            var d = document.querySelector('cart-drawer');
            if (d && _drawerObserver) _drawerObserver.observe(d, { childList: true, subtree: true });
          } catch(e){}
          _reapplyInProgress = false;
        }, 50);
      }, 120);
    });
    _drawerObserver.observe(drawer, { childList: true, subtree: true });
  }
  /* Install au boot + après ouverture drawer */
  setTimeout(installDrawerObserver, 300);
  document.addEventListener('cartUpdated', function(){ setTimeout(installDrawerObserver, 100); });
})();
